import React from "react";

import { Error } from "@mui/icons-material";
import { Box, Grid, TextField, Typography, useTheme } from "@mui/material";

interface MapOrganisationProps {
  handleDisableOrgMapping: (isDisabled: boolean) => void;
  handleMapRequestChanged: (orgMapRequest: string) => void;
}
const MapOrganisation = ({
  handleDisableOrgMapping,
  handleMapRequestChanged,
}: MapOrganisationProps) => {
  const theme = useTheme();

  return (
    <>
      <Grid container direction="row" spacing={1} style={{ minWidth: 350 }}>
        <Grid item xs={12} container direction="column">
          <Box
            bgcolor={theme.palette.warning.main}
            borderRadius="5px"
            border={1}
            borderColor={theme.palette.warning.main}
            marginBottom={3}
          >
            <Grid container alignItems="center">
              <Grid item xs={2} container justifyContent="center">
                <Error fontSize="large" />
              </Grid>
              <Grid item xs={10} style={{ paddingRight: "20px" }}>
                <p>
                  You are about to <b>initiate a mapping process</b>
                  {` that will
                  quantify this organisation's data. This process can `}
                  <b>take a long time.</b>
                </p>
                <p>
                  The mapping process will assess how much data the organisation
                  has for each product feature, and will help to estimate the
                  effort to migrate the organisation.
                </p>
              </Grid>
            </Grid>
          </Box>
        </Grid>
        <Grid item xs={12}>
          <Box>
            <Typography variant="body1">
              Provide the link to the customer request
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12}>
          <TextField
            id="customerMapRequest-input"
            label="Link to customer request"
            onChange={(event) => {
              handleMapRequestChanged(event.target.value.trim());
              handleDisableOrgMapping(event.target.value.length === 0);
            }}
            variant="outlined"
            size="small"
            fullWidth
            inputProps={{
              "data-anchor": "do-customerMapRequest-input",
              "data-testid": "do-customerMapRequest-input",
            }}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default MapOrganisation;
